import React from 'react';
import { SecuredPaymentClient } from 'Core/Api/Payment/SecuredPaymentClient';

export class GeneralNotificationHandler {
  GetNotification() {
    let client = new SecuredPaymentClient();
    client.showLoading = false;
    return client.notifications();
  }
}
